import type { IValidationField } from '../types';
import * as yup from 'yup';

export default function requireString({ label = '', defaultValue = '' }: IValidationField) {
  return yup.string().label(label).required().default(defaultValue.toString());
}
